export default __webpack_public_path__ + "static/media/hero-internationalization-us-en.678bcc4c.gif";